module.exports = __webpack_public_path__ + "img/img_cost_labor.0a0db5a8.jpg";